import React, { ReactNode, useCallback } from 'react';
import { useIntl } from 'react-intl';

import Search, { SearchEvent } from 'carbon-react/lib/components/search';

import styles from './listing-page-filter-bar.scss';

interface ListingPageFilterBarProps {
  children?: ReactNode;
  onSearchChange: (value: string) => void;
  searchTerm: string;
  stickyTop?: number;
  rightContent?: ReactNode;
  style?: React.CSSProperties;
}

export const ListingPageFilterBar = ({
  searchTerm,
  onSearchChange,
  children,
  stickyTop,
  rightContent,
  style
}: ListingPageFilterBarProps) => {
  const intl = useIntl();

  const handleSearchChange = useCallback(
    (event: SearchEvent) => {
      onSearchChange(event.target.value);
    },
    [onSearchChange]
  );

  return (
    <div
      className={styles.filterHeader}
      style={{ top: stickyTop !== undefined ? `${stickyTop}px` : undefined, ...style }}
    >
      <div className={styles.filterHeaderRow}>
        <div className={styles.searchContainer}>
          <Search
            id="listing-page-search"
            label={intl.formatMessage({ id: 'common.search', defaultMessage: 'Search' })}
            value={searchTerm}
            onChange={handleSearchChange}
            inputWidth={100}
          />
        </div>
        {children}
      </div>
      <div>{rightContent}</div>
    </div>
  );
};
